import { Spin } from "@pankod/refine-antd";
import React from "react";

export const LoadingFullPage: React.FC<{ text?: string }> = ({ text = "Loading..." }) => {
  return <Spin tip={text} className="w-full h-screen flex flex-col justify-center items-center" />;
};
